/**
 * AuthCard — the centered card composite used by the Login and Signup pages.
 * Matches the design-system.md auth-card composite (§4).
 */

import type { ReactNode } from 'react';
import styles from './AuthCard.module.css';
import { t } from '@/lib/i18n';

interface AuthCardProps {
  title: string;
  subtitle?: string;
  tagline?: string;
  taglineDetail?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthCard({
  title,
  subtitle,
  tagline,
  taglineDetail,
  children,
  footer,
}: AuthCardProps) {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {tagline ? (
          <div className={styles.taglineArea}>
            <p className={styles.tagline}>{tagline}</p>
            {taglineDetail ? <p className={styles.taglineDetail}>{taglineDetail}</p> : null}
          </div>
        ) : null}
        <header className={styles.header}>
          <div className={styles.brand}>{t('Linqage')}</div>
          <h1 className={styles.title}>{title}</h1>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </header>
        <div className={styles.body}>{children}</div>
        {footer ? <div className={styles.footer}>{footer}</div> : null}
      </div>
    </div>
  );
}
